export class ActionLog {
  public action: string;
  public createdDate: Date;
  public id: number;
  public message: string;
  public ownerID: number;
  public respondentID: number;
}
